import React from 'react';
import Select from 'react-select';
import {useSelector} from 'react-redux';
import {accountRoleOptions} from './accountRoles';

export function AccountRoleSelect({item, handleChange, setSelectOpen}) {
  const available =
    useSelector((state) => state.team.peopleAvailableRoles) || [];
  const selected = item.accountRoles || [];
  const previous = item.expectedAccountRoles || [];
  const inputId = `people-account-roles-${item.sourceTeamId || item.teamId}-${item._id}`;
  const setOpen = setSelectOpen('roles');
  return (
    <div className="people-account-role">
      <label className="people-role-label" htmlFor={inputId}>
        ROLES
      </label>
      <Select
        inputId={inputId}
        aria-label="Account roles"
        className="people-account-role-control"
        classNamePrefix="people-role-select"
        isMulti
        isSearchable={false}
        isClearable={false}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        blurInputOnSelect={false}
        menuPlacement="top"
        placeholder=""
        options={accountRoleOptions}
        value={accountRoleOptions.filter(({value}) => selected.includes(value))}
        isOptionDisabled={({value}) =>
          !available.includes(value) && !previous.includes(value)
        }
        onChange={(values) =>
          handleChange(
            'accountRoles',
            (values || []).map(({value}) => value)
          )
        }
        onMenuOpen={() => setOpen(true)}
        onMenuClose={() => setOpen(false)}
      />
    </div>
  );
}

export function AccountRoleCell({
  item,
  config,
  calculatePositionOfStickyHeaders,
}) {
  const highest = accountRoleOptions.find(({value}) =>
    item.accountRoles?.includes(value)
  );
  return (
    <td
      className="role-cell text-center"
      style={{
        ...calculatePositionOfStickyHeaders(config),
        verticalAlign: 'middle',
      }}
    >
      {highest ? (
        <span className={`role-${highest.value}`}>{highest.label}</span>
      ) : (
        '—'
      )}
    </td>
  );
}
